@if (visible) {
  <div class="recherche-operation">
    <div class="recherche-operation__overlay" (click)="fermer.emit()"></div>
    <div class="recherche-operation__panel" role="dialog" aria-modal="true"
      aria-labelledby="recherche-operation-titre" (keydown)="gererClavier($event)">
      <div class="recherche-operation__header">
        <div>
          <h3 id="recherche-operation-titre">Rechercher une opération</h3>
          <p>Opérations enregistrées, pointées ou non. Tous les filtres sont optionnels.</p>
        </div>
        <button type="button" class="recherche-operation__close" aria-label="Fermer la recherche"
          (click)="fermer.emit()">&times;</button>
      </div>
      <div class="recherche-operation__body">
        <form #formulaire="ngForm" (ngSubmit)="rechercher(formulaire)"
          (input)="effacerResultats()" (change)="effacerResultats()" class="recherche-operation__form">
          <div class="recherche-operation__grid">
            <label class="recherche-operation__libelle">
              Libellé
              <input #libelleInput type="text" name="libelle" [(ngModel)]="filtres.libelle"
                maxlength="255" [placeholder]="filtres.modeLibelle === 'REGEX' ? 'Ex. : ^(loyer|charges)' : 'Ex. : CARREFOUR ou *CARREFOUR*'" />
            </label>
            <label>
              Recherche du libellé
              <select name="modeLibelle" [(ngModel)]="filtres.modeLibelle">
                <option value="JOKERS">Contient / jokers (*, ?)</option>
                <option value="EXACT">Libellé exact</option>
                <option value="REGEX">Expression régulière (regex)</option>
                <option value="APPROCHANT">Approchant (fautes de frappe)</option>
              </select>
              <small>{{ aideLibelle }}</small>
            </label>
            <label>
              Catégorie
              <select name="categorie" [(ngModel)]="filtres.categorie">
                <option value="">Toutes les catégories</option>
                @for (categorie of categories; track categorie.id) {
                  <option [value]="categorie.nom">{{ categorie.nom }}</option>
                }
              </select>
            </label>
            <label>
              Type
              <select name="type" [(ngModel)]="filtres.type">
                <option value="">Sorties et entrées</option>
                <option value="SORTIE">Sortie</option>
                <option value="ENTREE">Entrée</option>
              </select>
            </label>
            <label>
              Compte
              <select name="compteId" [(ngModel)]="filtres.compteId">
                <option [ngValue]="null">Tous les comptes</option>
                @for (compte of comptes; track compte.id) {
                  <option [ngValue]="compte.id">{{ compte.nom }}</option>
                }
              </select>
            </label>
            <label>
              Moyen de paiement
              <select name="moyenPaiement" [(ngModel)]="filtres.moyenPaiement">
                <option value="">Tous les moyens</option>
                @for (moyen of moyensPaiement; track moyen.value) {
                  <option [value]="moyen.value">{{ moyen.label }}</option>
                }
              </select>
            </label>
          </div>
          <fieldset>
            <legend>Montant <small>Valeur positive, en euros</small></legend>
            <div class="recherche-operation__plage">
              <label>
                Recherche du montant
                <select name="modeMontant" [(ngModel)]="filtres.modeMontant">
                  <option value="EXACT">Montant exact</option>
                  <option value="PLAGE">Plage de montants</option>
                  <option value="POURCENTAGE">Montant ± 10 %</option>
                  <option value="EUROS">Montant ± X €</option>
                </select>
              </label>
              @if (filtres.modeMontant !== 'PLAGE') {
                <label>Montant
                  <input type="text" appMontant name="montant" [(ngModel)]="filtres.montant" min="0" max="9999999999.99" />
                </label>
                @if (filtres.modeMontant === 'EUROS') {
                  <label>Tolérance (± €)
                    <input type="text" appMontant name="toleranceEuros" [(ngModel)]="filtres.toleranceEuros"
                      min="0" max="9999999999.99" [required]="filtres.montant !== null" />
                  </label>
                }
              } @else {
                <label>Minimum
                  <input type="text" appMontant name="montantMin" [(ngModel)]="filtres.montantMin" min="0" max="9999999999.99" />
                </label>
                <label>Maximum
                  <input type="text" appMontant name="montantMax" [(ngModel)]="filtres.montantMax" min="0" max="9999999999.99" />
                </label>
              }
            </div>
            @if (plageMontant; as plage) {
              <small>Plage recherchée : {{ plage.min | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
                à {{ plage.max | currency:'EUR':'symbol':'1.2-2':'fr-FR' }} (bornes incluses).</small>
            }
          </fieldset>
          <fieldset>
            <legend>Date de l’opération</legend>
            <div class="recherche-operation__plage">
              <label>
                Recherche de date
                <select name="modeDate" [(ngModel)]="filtres.modeDate">
                  <option value="PLAGE">Période</option>
                  <option value="EXACT">Date exacte</option>
                </select>
              </label>
              @if (filtres.modeDate === 'EXACT') {
                <label>Date
                  <input type="date" name="date" [(ngModel)]="filtres.date" min="1000-01-01" max="9999-12-31" />
                </label>
              } @else {
                <label>Du
                  <input type="date" name="dateDebut" [(ngModel)]="filtres.dateDebut" min="1000-01-01" max="9999-12-31" />
                </label>
                <label>Au
                  <input type="date" name="dateFin" [(ngModel)]="filtres.dateFin" min="1000-01-01" max="9999-12-31" />
                </label>
              }
            </div>
          </fieldset>
          <div class="recherche-operation__actions">
            <button type="button" class="recherche-operation__secondaire" (click)="reinitialiser()">Réinitialiser</button>
            <button type="submit" [disabled]="chargement()">{{ chargement() ? 'Recherche…' : 'Rechercher' }}</button>
          </div>
        </form>
        @if (erreur()) { <p class="recherche-operation__erreur" role="alert">{{ erreur() }}</p> }
        @if (chargement()) { <p role="status">Recherche en cours…</p> }
        @if (resultat(); as resultats) {
          <section #resultatsZone tabindex="-1" aria-label="Résultats de la recherche" class="recherche-operation__resultats">
            <p role="status">{{ resultats.total }} opération{{ resultats.total > 1 ? 's' : '' }} trouvée{{ resultats.total > 1 ? 's' : '' }}</p>
            @if (resultats.total === 0) {
              <p class="recherche-operation__vide">Aucune opération ne correspond aux filtres.</p>
            } @else {
              <div class="recherche-operation__table">
                <table>
                  <caption>Résultats du plus récent au plus ancien</caption>
                  <thead><tr>
                    <th scope="col">Date</th><th scope="col">Libellé</th><th scope="col">Compte</th>
                    <th scope="col">Catégorie</th><th scope="col">Paiement</th>
                    <th scope="col">Montant</th><th scope="col">Statut</th>
                  </tr></thead>
                  <tbody>
                    @for (operation of resultats.operations; track operation.id) {
                      <tr>
                        <td class="recherche-operation__date">{{ operation.dateOperation | date:'dd/MM/yyyy' }}</td>
                        <td>{{ operation.libelle }}
                          @if (operation.operationPlanifieeLibelle) {
                            <small>Liée à : {{ operation.operationPlanifieeLibelle }}</small>
                          }
                        </td>
                        <td>{{ operation.compteNom }}</td><td>{{ operation.categorie || '—' }}</td>
                        <td>{{ moyenPaiement(operation.moyenPaiement) }}
                          @if (operation.numeroCheque) { <small>N° {{ operation.numeroCheque }}</small> }
                        </td>
                        <td class="recherche-operation__montant" [class.recherche-operation__montant--sortie]="operation.type === 'SORTIE'">
                          {{ (operation.type === 'SORTIE' ? -operation.montant : operation.montant) | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
                        </td>
                        <td>{{ operation.estPointee ? 'Pointée' : 'Non pointée' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              @if (nombrePages > 1) {
                <nav class="recherche-operation__pagination" aria-label="Pages des résultats">
                  <button type="button" class="recherche-operation__secondaire"
                    [disabled]="chargement() || resultats.page <= 1" (click)="chargerPage(resultats.page - 1)">Précédent</button>
                  <span>Page {{ resultats.page }} / {{ nombrePages }}</span>
                  <button type="button" class="recherche-operation__secondaire"
                    [disabled]="chargement() || resultats.page >= nombrePages" (click)="chargerPage(resultats.page + 1)">Suivant</button>
                </nav>
              }
            }
          </section>
        } @else if (!chargement() && !erreur()) {
          <p class="recherche-operation__vide">Choisissez vos filtres, puis cliquez sur « Rechercher ».</p>
        }
      </div>
      <div class="recherche-operation__footer">
        <button type="button" class="recherche-operation__secondaire" (click)="fermer.emit()">Fermer</button>
      </div>
    </div>
  </div>
}
